import { useEffect } from 'react';
import { logEvent } from 'firebase/analytics';

import HomePageHero from '../../sections/Homepage/HomePageHero';
import { MyHelmet } from './MyHelmet';
import { analytics } from '../../config/firebase';

export default function Home() {
  // Firebase analytics
  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_title: 'Home',
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }, []);
  return (
    <>
      <MyHelmet />
      <HomePageHero />
    </>
  );
}
